import { createAction } from 'typesafe-actions';
import { ILevelState } from './ILevelState';
import { IScoreEntry } from '../../Utility/SDK/ISDKDriver';

enum Types {
    SET_LEVEL_STATE = 'setLevelState',
    LEVEL_INTRO = 'levelIntro',
    LEVEL_ACTIVE = 'levelActive',
    LEVEL_END = 'levelEnd',
    SET_LEVEL_LEADERBOARD = 'setLevelLeaderboard',
}

export const LevelActions = {
    setLevelState: createAction(
        Types.SET_LEVEL_STATE,
        resolve => (levelState: Partial<ILevelState>) => resolve(levelState)
    ),
    levelIntro: createAction(Types.LEVEL_INTRO),
    levelActive: createAction(Types.LEVEL_ACTIVE),
    setLevelLeaderboard: createAction(
        Types.SET_LEVEL_LEADERBOARD,
        resolve => (entries: IScoreEntry[]) => resolve<IScoreEntry[]>(entries)
    ),
    levelEnd: createAction(Types.LEVEL_END),
};
